//生成唯一的ID--------------------------------
// UUID 生成函数
function generateUUID() {
    var d = new Date().getTime();
    var d2 = (performance && performance.now && (performance.now() * 1000)) || 0;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
}
// 获取或生成设备ID
function getDeviceId() {
    let deviceId = localStorage.getItem('deviceId');
    if (!deviceId) {
        // 如果 localStorage 中没有设备ID，就生成一个新的
        deviceId = generateUUID();
        localStorage.setItem('deviceId', deviceId);
    }
    return deviceId;
}
const deviceId = getDeviceId();




//API----------------------------------------
const baseUrl = 'https://fitment.lasfit.com/prod-api'

// 用户登录
function userLogin(email, deviceId) {
    const url = baseUrl + '/web/login';
    const data = {
        email: email,
        deviceId: deviceId,
    };

    // 返回一个 Promise
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then(response => response.json())
        .catch((error) => {
            console.error('登录错误:', error);
            throw error; // 抛出错误以便在调用处处理
        });
}

// 用户登出
function userLogout(email, deviceId) {
    const url = baseUrl + '/web/logout';
    const data = {
        email: email,
        deviceId: deviceId,
    };

    // 返回一个 Promise
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then(response => response.json())
        .catch((error) => {
            console.error('登出错误:', error);
            throw error; // 抛出错误以便在调用处处理
        });
}

// 检查是否有主车型
function checkMainVehicle(deviceId) {
    const url = baseUrl + '/web/user/memory/main-car-model';
    const params = new URLSearchParams({ deviceId: deviceId });
    const fullUrl = `${url}?${params.toString()}`;


    // 返回一个 Promise
    return fetch(fullUrl, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(response => response.json())
        .catch((error) => {
            console.error('检查主车型错误:', error);
            throw error; // 抛出错误以便在调用处处理
        });
}

// 获取 YMM 树
function getYmmData() {
    const url = baseUrl + '/web/datasource/year-make-model-tree';

    // 返回一个 Promise
    return fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(response => response.json())
        .catch((error) => {
            console.error('获取 YMM 数据错误:', error);
            throw error; // 抛出错误以便在调用处处理
        });
}

//查询用户车库
function getUserVehicleList(deviceId) {
    const url = baseUrl + '/web/user/memory/garage';
    const params = new URLSearchParams({ deviceId: deviceId });
    const fullUrl = `${url}?${params.toString()}`;
    // 返回一个 Promise
    return fetch(fullUrl, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(response => response.json())
        .catch((error) => {
            console.error('检查主车型错误:', error);
            throw error; // 抛出错误以便在调用处处理
        });
}

// 删除车库车型
function deleteVehicle(email, deviceId, year, make, model, main) {
    const url = baseUrl + '/web/user/memory/garage';
    const data = {
        deviceId: deviceId,
        year: year,
        make: make,
        model: model,
        main: main,
        email: email ? email : null,
    };
    // 返回一个 Promise
    return fetch(url, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then(response => response.json())
        .catch((error) => {
            console.error('删除错误:', error);
            throw error; // 抛出错误以便在调用处处理
        });
}

// 新增或者切换主车型
function addOrSwitchMainVehicle(email, deviceId, year, make, model, main) {
    const url = baseUrl + '/web/user/memory/main-car-model';
    const data = {
        deviceId: deviceId,
        year: year,
        make: make,
        model: model,
        main: main,
        email: email ? email : null,
    };
    // 返回一个 Promise
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then(response => response.json())
        .catch((error) => {
            console.error('添加或修改错误:', error);
            throw error; // 抛出错误以便在调用处处理
        });
}

//清空仓库车型
function deleteAllVehicle(email, deviceId) {
    const url = baseUrl + '/web/user/memory/garage/clean';
    const data = {
        deviceId: deviceId,
        email: email ? email : null
    };
    // 返回一个 Promise
    return fetch(url, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then(response => response.json())
        .catch((error) => {
            console.error('清空出错:', error);
            throw error; // 抛出错误以便在调用处处理
        });
}

//获取产品类目页页的数据
function getProductCategoryData(year, make, model) {
    const url = baseUrl + `/web/datasource/${year}/${make}/${model}`;
    // 返回一个 Promise
    return fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(response => response.json())
        .catch((error) => {
            console.error('检查主车型错误:', error);
            throw error; // 抛出错误以便在调用处处理
        });
}

//产品集合页详情获取locations
function getLocations(year, make, model, category, subModels = []) {
    const url = baseUrl + `/web/datasource/locations`;
    const data = {
        year: year,
        make: make,
        model: model,
        category: category,
    };
    if (subModels) {
        subModels.forEach((subModel, index) => {
            data[`subModel${index + 1}`] = subModel;
        });
    }
    // 返回一个 Promise
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then(response => response.json())
        .catch((error) => {
            console.error('查询错误:', error);
            throw error; // 抛出错误以便在调用处处理
        });
}

//产品集合页详情获取subModel
function getSubModel(deviceId, year, make, model, category, locations) {
    const url = baseUrl + `/web/datasource/sub-model`;
    const data = {
        deviceId: deviceId,
        year: year,
        make: make,
        model: model,
        category: category,
        locations: locations ? locations : []
    };
    // 返回一个 Promise
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then(response => response.json())
        .catch((error) => {
            console.error('查询错误:', error);
            throw error; // 抛出错误以便在调用处处理
        });
}

//新增用户记忆 subModel
function addMemorySubModel(email, deviceId, year, make, model, subModel) {
    const url = baseUrl + '/web/user/memory/sub-model';
    const data = {
        deviceId: deviceId,
        year: year,
        make: make,
        model: model,
        subModel: subModel,
        email: email ? email : null,
    };
    // 返回一个 Promise
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then(response => response.json())
        .catch((error) => {
            console.error('新增记忆错误:', error);
            throw error; // 抛出错误以便在调用处处理
        });
}

//清除客户此车型选择的所有subModels
function deleteMemorySubModel(email, deviceId, year, make, model) {
    const url = baseUrl + '/web/user/memory/sub-models';
    const data = {
        deviceId: deviceId,
        year: year,
        make: make,
        model: model,
        email: email ? email : null,
    };
    // 返回一个 Promise
    return fetch(url, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then(response => response.json())
        .catch((error) => {
            console.error('清除记忆错误:', error);
            throw error; // 抛出错误以便在调用处处理
        });
}

//获取产品集合的产品
function getProductList(deviceId, year, make, model, category, subModels = [], locations = []) {
    const url = baseUrl + `/web/datasource/products`;
    const data = {
        deviceId: deviceId,
        year: year,
        make: make,
        model: model,
        category: category,
        locations: locations ? locations : [],
    };
    if (subModels) {
        subModels.forEach((subModel, index) => {
            data[`subModel${index + 1}`] = subModel;
        });
    }
    // 返回一个 Promise
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then(response => response.json())
        .catch((error) => {
            console.error('查询错误:', error);
            throw error; // 抛出错误以便在调用处处理
        });

}

//获取产品详情页的信息
function getProductDetail(deviceId, productId) {
    const url = baseUrl + `/web/datasource/products/${productId}/info`;
    const data = {
        deviceId: deviceId,
    };
    // 返回一个 Promise
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then(response => response.json())
        .catch((error) => {
            console.error('查询错误:', error);
            throw error; // 抛出错误以便在调用处处理
        });
}

//获取产品弹窗的YMM树
function getProductModalYmmTree(productId) {
    const url = baseUrl + `/web/datasource/products/${productId}/popout/ymm-tree`;

    // 返回一个 Promise
    return fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
    })
        .then(response => response.json())
        .catch((error) => {
            console.error('查询错误:', error);
            throw error; // 抛出错误以便在调用处处理
        });
}

//获取产品弹窗信息
function getProductModalInfo(deviceId, year, make, model, id, subModels = []) {
    const url = baseUrl + `/web/datasource/products/${id}/popout`;
    const data = {
        deviceId: deviceId,
        year: year,
        make: make,
        model: model,
    };
    if (subModels) {
        subModels.forEach((subModel, index) => {
            data[`subModel${index + 1}`] = subModel;
        });
    }
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then(response => response.json())
        .catch(error => {
            console.error('查询错误:', error);
            throw error; // 抛出错误以便在调用处处理
        })
}

//产品弹窗记忆
function addProductModalMemory(email, deviceId, year, make, model, subModels, main = true) {
    const url = baseUrl + '/web/user/memory/main-car-model/sub-models';
    const data = {
        deviceId: deviceId,
        year: year,
        make: make,
        model: model,
        main: main,
        subModels: subModels,
        email: email ? email : null,
    };

    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then(response => response.json())
        .catch(error => {
            console.error('查询错误:', error);
            throw error; // 抛出错误以便在调用处处理
        })
}

//通用推荐
function getUniversalRecommendProducts(startIndex, endIndex, year, make, model, deviceId) {
    const url = baseUrl + `/web/universal/recommend`;
    const data = {
        deviceId: deviceId,
        year: year,
        make: make,
        model: model,
        startIndex: startIndex,
        endIndex: endIndex,
    };
    // 返回一个 Promise
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then(response => response.json())
        .catch((error) => {
            console.error('查询错误:', error);
            throw error; // 抛出错误以便在调用处处理
        });
}

// 产品页面推荐
function getRecommendProductsFromPage(year, make, model, deviceId, productId, locations = []) {
    const url = baseUrl + `/web/product/recommend`;
    const data = {
        deviceId: deviceId,
        year: year,
        make: make,
        model: model,
        productId: productId,
        locations: locations,
    };
    // 返回一个 Promise
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then(response => response.json())
        .catch((error) => {
            console.error('查询错误:', error);
            throw error; // 抛出错误以便在调用处处理
        });
}



//加密函数---------------------------------
function encodeData(data) {
    if(!data) {return ''}
    if (Object.keys(data).length > 0) {
        // 将 localData 对象转换为 JSON 字符串
        let jsonString = JSON.stringify(data);
        // 对 JSON 字符串进行 Base64 编码
        let base64Encoded = btoa(jsonString);
        // 将 Base64 编码的结果转换为 URL-safe 格式
        let urlSafeBase64Encoded = base64Encoded
            .replace(/\+/g, '-')  // 替换 '+' 为 '-'
            .replace(/\//g, '_')  // 替换 '/' 为 '_'
            .replace(/=+$/, '');  // 去掉尾部的 '='

        return urlSafeBase64Encoded;
    }
    return '';
}
function decodeData(urlSafeBase64Encoded) {
    if (urlSafeBase64Encoded) {
        let standardBase64Encoded = urlSafeBase64Encoded
            .replace(/-/g, '+')  // 替换 '-' 为 '+'
            .replace(/_/g, '/')  // 替换 '_' 为 '/'
            + '==='.slice(0, (4 - urlSafeBase64Encoded.length % 4) % 4);  // 添加缺失的 '='
        try {
            let jsonStringDecoded = atob(standardBase64Encoded);
            let localDataDecoded = JSON.parse(jsonStringDecoded);
            return localDataDecoded;
        } catch (e) {
            return null;
        }
    } else {
        return null;
    }
}


function getDataFromUrl() {
    // 202605修改
    let paramNames = getQueryParamNames();
    let rawParam = paramNames[paramNames.length - 1];
    // Strip social media tracking params (&fbclid, &eab_tests, etc.)
    let ymmData = rawParam ? rawParam.split('&')[0].trim().replace(/=+$/, '') : rawParam;
    let res = decodeData(ymmData);
    return res;
}


function getQueryParamNames() {
    let url = window.location.href;
    // 创建 URL 对象
    let urlObj = new URL(url);
    // 获取所有查询参数
    let queryString = urlObj.search.split('?').filter(item => item); 
    // 返回参数名数组
    return queryString;
}




//标题转成句柄
function titleToHandle(title) {
    let handle = title.toLowerCase().replace(/ /g, '-');
    return handle;
}
//句柄转成标题
function handleToTitle(handle) {
    if (handle) {
        return handle
            .split('-')                   // 将句柄按横杠分割成数组
            .map(word =>                  // 遍历数组中的每个单词
                word.charAt(0).toUpperCase() + word.slice(1) // 将每个单词的首字母大写，后面的字母保持不变
            )
            .join(' ');                   // 将数组重新合并成字符串，单词之间用空格连接
    }

}

// 定义防抖函数
function debounce(func, wait) {
    let timeout;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
}

//定义节流函数
function throttle(func, delay) {
    let lastCall = 0;
    return function (...args) {
        const now = new Date().getTime();
        if (now - lastCall < delay) {
            return;
        }
        lastCall = now;
        return func.apply(this, args);
    };
}


//shopify接口   
function requestData(id) {
    // 定义 Storefront API 的请求参数
    const domain = 'lasfitled.myshopify.com';
    const accessToken = '389e24c85f6ead33ad99d147bd8ab191';
    const productId = id;

    // 构建 API 请求 URL
    const apiUrl = `https://${domain}/api/2024-07/graphql.json`;

    // 定义请求头
    const headers = {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': accessToken,
    };

    // 构建 GraphQL 查询字符串
    const query = `
        query {
          product(id: "gid://shopify/Product/${productId}") {
            title
            handle
            availableForSale
            totalInventory
            featuredImage{
                altText
                src
            }
               product_detail:metafield(key: "subtitle",namespace: "descriptors") {
              value
            }
            createdAt
            images(first: 50){
                edges{
                    node{
                        altText
                        src
                    }
                }
            }
            variants(first: 50){
                edges{
                  node{
                    price {
                      amount
                      currencyCode
                    }
                    compareAtPrice {
                      amount
                      currencyCode
                    }
                    id
                  }
                }
            }
          }
        }
     `;

    return fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ query: query }),
    })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.json();
        })
        .catch(error => {
            console.error(`Error fetching product with id ${id}:`, error);
            // 返回一个空对象或其他默认值，防止 Promise.all 被 reject
            return { data: null };
        });
}
//评论接口
function getPreviewBadge(externalId) {
    const url = baseUrl + `/web/judge?id=${externalId}`;
    // 返回一个 Promise
    return fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(response => response.json())
        .catch((error) => {
            console.error('查询评论错误:', error);
            throw error; // 抛出错误以便在调用处处理
        });
}

//获取collection-detail路径后的第一个路径
function getCollectionDetailPath() {
    let category = Cookies.get('category') || 'Led Bulbs'
    if (category) {
        return category;
    } else {
        return '';
    }
}


//产品加购的隐藏信息
function handleProductLocations(locations) {
    if (locations && locations.length > 0) {
        let locationText = '';
        for (const key in locations) {
            if (locations.hasOwnProperty(key)) {
                locationText += `&#9679;&nbsp;${locations[key]}&nbsp;&nbsp;`;
            }
        }
        return `<input type="hidden" name="properties[Location]" id="custom-property__location" value="${locationText}">`
    }
    return '';
}
function handleProductFitInfo(data) {
    if (!data) {
        return '';
    }
    let fitInfo = '';
    if (data.tag === 0) {
        fitInfo = data.fitment;
    } else if (data.tag === 2 || data.tag === 4) {
        fitInfo = `Fits Your ${data.ymm.year} ${data.ymm.make} ${data.ymm.model}`;
    } else if (data.tag === 5) {
        fitInfo = `Do Not Fit Your ${data.ymm.year} ${data.ymm.make} ${data.ymm.model} `;
    }
    return `<input type="hidden" name="properties[Vehicle]" id="custom-property__fit" value="${fitInfo}">`;
}
function handleProductsFitInfo(data) {
    if (!data) {
        return '';
    }
    let fitInfo = '';
    if (data.tag === 0) {
        fitInfo = data.fitment;
    }else if (data.tag ===1 || data.tag === 2){
        fitInfo = `Fits Your ${data.ymm.year} ${data.ymm.make} ${data.ymm.model}`;
    }
    return `<input type="hidden" name="properties[Vehicle]" id="custom-property__fit" value="${fitInfo}">`;
}
function handleProductInfo(info) {
    if (info && info.length > 0) {
        const infosList = `<input type="hidden" name="properties[Notice]" id="custom-property__showInfo" value="${info[0]}">`;
        return infosList;
    }
    return '';
}
function handleProductSubModels(subModels) {
    let subModelText = '';
    if (subModels) {
        for (const key in subModels) {
            if (subModels.hasOwnProperty(key)) {
                subModelText += `& ${subModels[key]}`;
            }
        }
        return `<input type="hidden" name="properties[Submodel]" id="custom-property__showSubModels" value="${subModelText.slice(1)}"></input>`;
    }
    return '';
}



//产品价格
function handleProductPrice(product) {
    let variants = product.variants;
    let edges = variants.edges;
    let currencyCode = edges[0].node.price.currencyCode;
    let currencySymbol = currencySymbols[currencyCode] || currencyCode;

    let prices = edges.map(edge => parseFloat(edge.node.price.amount));
    let compareAtPrices = edges.map(edge =>
        edge.node.compareAtPrice ? parseFloat(edge.node.compareAtPrice.amount) : null
    );

    let allPricesSame = prices.every(price => price === prices[0]);
    let allCompareAtPricesNull = compareAtPrices.every(price => price === null || price === 0);

    // 只有一个变体的情况
    if (edges.length === 1) {
        return formatPrice(prices[0], compareAtPrices[0], currencySymbol, true);
    }

    // 多个变体的情况
    if (allPricesSame && allCompareAtPricesNull) {
        return { nowPrice: `<span class='now-price'>${currencySymbol}${prices[0]}</span>` };
    } else if (allPricesSame) {
        let nonNullCompareAtPrices = compareAtPrices.filter(price => price !== null);
        let minCompareAtPrice = Math.max(...nonNullCompareAtPrices);
        return formatPrice(prices[0], minCompareAtPrice, currencySymbol, false);
    } else {
        let minPrice = Math.min(...prices);
        let maxPrice = Math.max(...prices);
        let compareMaxAtPrice = compareAtPrices[prices.indexOf(maxPrice)];
        let compareMinAtPrice = compareAtPrices[prices.indexOf(minPrice)];
        return formatPrice(minPrice, maxPrice, currencySymbol, false, compareMinAtPrice);
    }
}
function formatPrice(price, compareAtPrice, currencySymbol, isSingleVariant, compareMinPrice = null) {
    price = parseFloat(price).toFixed(2);
    compareAtPrice = compareAtPrice ? parseFloat(compareAtPrice).toFixed(2) : null;
    compareMinPrice = compareMinPrice ? parseFloat(compareMinPrice).toFixed(2) : null;
    if (isSingleVariant) {
        if (!compareAtPrice || compareAtPrice === price) {
            return { nowPrice: `<span class='now-price'>${currencySymbol}${price}</span>` };
        } else {
            return {
                nowPrice: `<span class='after-price'>${currencySymbol}${price}</span><span class='before-price'>${currencySymbol}${compareAtPrice}</span>`
            };
        }
    } else {
        if (!compareAtPrice || compareAtPrice === price) {
            return { nowPrice: `<span class='now-price'>${currencySymbol}${price}</span>` };
        } else {
            return {
                nowPrice: `<span class='after-price'>${currencySymbol}${price}</span><span>-</span><span class='after-price'>${currencySymbol}${compareAtPrice}</span>`,
                sameVariantPrice: `<span class='after-price'>${currencySymbol}${price}</span><span>-</span><span class='after-price'>${currencySymbol}${compareMinPrice}</span>`
            };
        }
    }
}

//处理产品的标签
function handleProductTag(product, price, limitDays) {
    let tag1, tag2, tag3;
    if (!product.availableForSale) {
        tag1 = `<div class="product-card-tag product-card-tag_sold-out">
            <span>
              <svg class="icon icon--check_mark" width='14' height='14' viewBox='0 0 16 16' aria-hidden="true" focusable="false" role="presentation">
                <path fill="currentColor" fill-rule="evenodd" d="M14.441 3.733a.5.5 0 010 .707l-7.94 7.94a.5.5 0 01-.707 0L2.52 9.105a.5.5 0 11.707-.707l2.922 2.922 7.586-7.587a.5.5 0 01.707 0z" clip-rule="evenodd"/>
              </svg>
              Sold out
            </span>
          </div>`;
    } else {
        tag1 = '';
    }
    const spanTags = price ? price.match(/<span[^>]*>(.*?)<\/span>/g) : null;
    if (spanTags && spanTags.length >= 2) {
        const amounts = spanTags
            .map((tag) => {
                // 使用正则提取货币符号和金额
                const match = tag.match(/([¥$€£])(\d+(\.\d{1,2})?)/);
                return match ? {
                    currency: match[1], // 货币符号
                    amount: parseFloat(match[2]), // 将金额转换为浮点数
                } : null;
            })
            .filter(Boolean); // 过滤掉没有匹配到的项

        if (amounts.length > 1) {
            const originalPrice = amounts[1]?.amount; // 可能不存在 originalPrice
            const discountedPrice = amounts[0].amount;

            // 如果没有 originalPrice，则直接返回空字符串
            if (!originalPrice) {
                tag2 = '';
            } else {
                const discountPercentage = ((originalPrice - discountedPrice) / originalPrice) * 100;
                const discountTag = (percentage, prefix = '') => `
               
                   <div class="product-card-tag product-card-tag_discount">
                        <span>
                            <svg class="icon icon--price_tag" width="14" height="14" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation">
                                <path fill="currentColor" d="M7.59 1.34a1 1 0 01.7-.29h5.66a1 1 0 011 1v5.66a1 1 0 01-.3.7L7.6 15.5a1 1 0 01-1.42 0L.52 9.83a1 1 0 010-1.42l7.07-7.07zm6.36 6.37l-7.07 7.07-5.66-5.66L8.3 2.05h5.66v5.66z" fill-rule="evenodd"/>
                                <path fill="currentColor" d="M9.7 6.3a1 1 0 101.42-1.42 1 1 0 00-1.41 1.41zM9 7a2 2 0 102.83-2.83A2 2 0 009 7z" fill-rule="evenodd"/>
                            </svg>
                            ${prefix}${percentage.toFixed(0)}% off
                        </span>
                    </div>`;
                
                // 根据 spanTags 的数量决定折扣显示方式
                tag2 = spanTags.length === 2 ? discountTag(discountPercentage) : discountTag(discountPercentage, 'Up to ');
            }
        } else {
            tag2 = '';
        }
    } else {
        tag2 = '';
    }



    const now = new Date();
    const createdTime = new Date(product.createdAt);
    const diffTime = Math.abs(now - createdTime); // 获取时间差，单位为毫秒
    const diffDays = diffTime / (1000 * 60 * 60 * 24); // 转换为天数
    // 如果差值在 limitDays 内，返回 "New"，否则返回空字符串
    if (diffDays <= limitDays) {
        tag3 = `<div class="product-card-tag product-card-tag_new">New</div>`;
    } else {
        tag3 = '';
    }
    return `${tag1}${tag2}${tag3}`;
}





const currencySymbols = {
    'USD': '$',    // 美元
    'EUR': '€',    // 欧元
    'GBP': '£',    // 英镑
    'JPY': '¥',    // 日元
    'CNY': '¥',    // 人民币
    'AUD': '$',    // 澳大利亚元
    'CAD': '$',    // 加拿大元
    'CHF': 'CHF',  // 瑞士法郎
    'NZD': '$',    // 新西兰元
    'INR': '₹',    // 印度卢比
    'RUB': '₽',    // 俄罗斯卢布
    'KRW': '₩',    // 韩元
    'SGD': '$',    // 新加坡元
    'HKD': '$',    // 港元
    'SEK': 'kr',   // 瑞典克朗
    'NOK': 'kr',   // 挪威克朗
    'TRY': '₺',    // 土耳其里拉
    'MXN': '$',    // 墨西哥比索
    'BRL': 'R$',   // 巴西雷亚尔
    'ZAR': 'R'     // 南非兰特
};